import Swal from "sweetalert2";

export const getAlert = (title, message, type) => {
  Swal.fire({
    title: title,
    text: message,
    icon: type,
    confirmButtonText: "Close",
    customClass: {
      confirmButton: "swal2-outline-red",
    },
    didOpen: () => {
      const confirmButton = Swal.getConfirmButton();
      confirmButton.innerHTML = `
                <i class="fa fa-times" style="margin-right: 8px; margin-left:3px; font-size:"6px"></i> Close`;
    },
  });
};

export const getConfirmAlert = (title, message, type) => {
  return Swal.fire({
    title: title,
    text: message,
    icon: type,
    showCancelButton: true,
    confirmButtonText: "Yes",
    cancelButtonText: "No",
    customClass: {
      confirmButton: "swal2-outline-black",
      cancelButton: "swal2-outline-red",
    },
    didOpen: () => {
      const confirmButton = Swal.getConfirmButton();
      confirmButton.innerHTML = `
                <i class="fa fa-check" style="margin-right: 8px;"></i> Yes`;

      const cancelButton = Swal.getCancelButton();
      cancelButton.innerHTML = `
                <i class="fa fa-times" style="margin-right: 8px; margin-left:3px;"></i> No`;
    },
  }).then((result) => {
    return result;
  });
};

export const getConfirmAlertWithAuth = (title, message, type) => {
  return Swal.fire({
    title: title,
    text: message,
    icon: type,
    showCancelButton: true,
    confirmButtonText: "Yes",
    cancelButtonText: "No",
    customClass: {
      confirmButton: "swal2-outline-black",
      cancelButton: "swal2-outline-red",
    },
    didOpen: () => {
      const confirmButton = Swal.getConfirmButton();
      confirmButton.innerHTML = `
                <i class="fa fa-check" style="margin-right: 8px;"></i> Yes`;

      const cancelButton = Swal.getCancelButton();
      cancelButton.innerHTML = `
                <i class="fa fa-times" style="margin-right: 8px; margin-left:3px;"></i> No`;
    },
  }).then(async (result) => {
    if (result.isConfirmed) {
      // Ask for authorization code
      while (true) {
        const { value: authCode, isConfirmed: codeConfirmed } = await Swal.fire(
          {
            title: "Enter Authorization Code",
            input: "password",
            inputLabel: "Required for deleting file",
            inputPlaceholder: "Enter code...",
            showCancelButton: true,
            confirmButtonText: "Verify",
            cancelButtonText: "Cancel",
            customClass: {
              confirmButton: "swal2-outline-black",
              cancelButton: "swal2-outline-red",
            },
          }
        );

        if (!codeConfirmed) {
          return { isConfirmed: false };
        }

        // Correct authorization code
        if (authCode === "12345") {
          return { isConfirmed: true };
        }

        // Wrong code → retry
        await Swal.fire({
          icon: "error",
          title: "Incorrect Code",
          text: "The authorization code is wrong. Try again.",
        });
      }
    }

    return { isConfirmed: false };
  });
};
